function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 216 290",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M211.89,131.926L211.89,27.677C211.89,27.677 211.89,4.41 188.615,4.41L142.055,4.41C145.785,6.746 148.231,10.89 147.895,15.586C147.411,22.354 141.509,27.44 134.767,26.956C116.765,25.665 98.253,24.332 90.058,25.028C90.645,27.593 91.596,30.913 92.369,33.613C101.064,64.038 110.158,91.381 123.584,125.932C135.158,122.281 147.47,120.302 160.242,120.302C178.717,120.302 196.179,124.547 211.89,131.926ZM74.413,4.41L26.818,4.41C26.818,4.41 3.543,4.41 3.543,27.677L3.543,55.618C22.972,53.516 45.231,51.595 71.378,49.416C70.494,46.418 69.62,43.413 68.745,40.364C65.077,27.525 62.181,17.386 69.17,8.785C70.652,6.958 72.438,5.589 74.413,4.41ZM83.902,88.995C82.128,83.764 80.421,78.601 78.765,73.455C49.025,75.925 24.47,77.987 3.543,80.288L3.543,173.129C5.694,170.709 7.704,168.474 9.993,165.884C28.436,145.012 51.287,119.19 83.902,88.995ZM3.543,209.44L3.543,261.998C3.543,261.998 3.543,285.265 26.818,285.265L46.106,285.265C41.064,271.896 38.176,257.479 38.176,242.368C38.176,196.539 63.565,156.552 101.013,135.68C98.117,128.242 95.417,121.134 92.878,114.248C65.17,140.563 44.978,163.397 28.394,182.154C19.504,192.211 11.43,201.307 3.543,209.44ZM170.949,239.004C173.666,245.221 170.822,252.463 164.606,255.172C163.01,255.877 161.337,256.2 159.697,256.2C154.959,256.2 150.451,253.449 148.439,248.829C132.763,212.91 120.374,183.827 110.184,158.734C81.788,175.794 62.733,206.899 62.733,242.368C62.733,257.772 66.422,272.299 72.811,285.265L188.615,285.265C188.615,285.265 211.89,285.265 211.89,261.998L211.89,159.823C196.891,150.404 179.219,144.868 160.242,144.868C150.671,144.868 141.433,146.278 132.695,148.851C142.843,173.875 155.214,202.942 170.949,239.004Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo_footer.0eab98e5f3c2d211c522fc0c884a5a04.svg";
export { ForwardRef as ReactComponent };